import axios from 'axios';
import { customEvent, generateLeadEvent } from '../modules/tracking/AnalyticsEvents';

axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

const form = document.getElementById('request-callback-form');

const validator = new ContactFormValidator({ element: form, reskin: true });
const handler = new CustomerLocationHandler({ element: form });

form.addEventListener('submit', e => {
    e.preventDefault();

    if (!validator.isValid()) {
        return;
    }

    const formData = new FormData(form);

    validator.preventInput();

    axios.post(form.getAttribute('action'), formData)
        .then(response => {
            validator.allowInput();

            document.getElementById('heading').classList.add('hidden');

            if (response.data.model && response.data.model_link) {
                document.getElementById('formWrapper').innerHTML = `
                <div class="form__thank-you">
                    <div class="container">
                        <h2 class="form__heading">Thank you for your request</h2>
                        <p>A confirmation email has been sent to your email address. We look forward to speaking with you! To continue your search or find your local dealership please click the links below:</p>
                        <div class="form__links">
                            <a class="btn btn-primary" href="${response.data.dealer}">Dealer directions</a>
                            <a class="btn btn-primary" href="${response.data.model_link}">Discover ${response.data.model}</a>
                        </div>
                    </div>
                </div>
                `;
            } else {
                document.getElementById('formWrapper').innerHTML = `
                <div class="form__thank-you">
                    <div class="container">
                        <h2 class="form__heading">Thank you for your request</h2>
                        <p>A confirmation email has been sent to your email address. We look forward to speaking with you! To continue your search or find your local dealership please click the links below:</p>
                        <div class="form__links">
                            <a class="btn btn-primary" href="${response.data.dealer}">Dealer directions</a>
                            <a class="btn btn-primary" href="${response.data.discover_mode}">Discover more</a>
                        </div>
                    </div>
                </div>
                `;
            }


            customEvent("Motability - Request a Callback", "Form", "Complete");
            generateLeadEvent('motability_request_callback');

            scrollToElementId('formWrapper');
        })
        .catch(e => {
            validator.errorResponse(e);
            scrollToElementId('formWrapper');
        })
})


// WEBPACK FOOTER //
// ./resources/assets/js/motability/request-a-callback.js